import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import LavorisService from "../../../services/LavorisService";
import useDisabledButton from "../../login/useDisabledButton.hook";
import { Link } from "react-router-dom";
import { SuccessModal } from "../../../components/others/SuccessModal";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import Spinner from "../../../components/others/Spinner/Spinner";
import { FranchiseLogo } from "../../../components/others/FranchiseBranding";
import { RootState } from "../../../store/combineReducer";
import { isFranchiseTenant } from "../../../utils/franchise/franchiseAbsenteeismMenu";

type TModalProps = {
    toggleModal?: boolean;
    urlTittle?: string;
    handleClose?: Function;
}

type FormValues = {
    username: string;
}

const ResetPasswordAlert = ({ urlTittle, handleClose }: TModalProps) => {

    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm({ defaultValues: { username: "", }, });
    const formUsername = watch("username") || "";
    const { disabled, setDisabled } = useDisabledButton();
    const [emailRequestSuccesfully, setEmailRequestSuccesfully] = useState(false)
    const [emailAddressSent, setEmailAddressSent] = useState('')
    const [emailFailed, setEmailFailed] = useState(false)
    const [user, setUser] = useState<any>(null)
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [wspSuccesfullySent, setwspSuccesfullySent] = useState<boolean>(false);
    const { showAlert } = useAlert();
    const franchiseState = useSelector((state: RootState) => state.franchise);
    const franchiseLayout = isFranchiseTenant(franchiseState);


    const LavorisInstance = LavorisService.getInstance();

    const onSubmit = async (data: FormValues) => {
        setDisabled(true)
        try {
            setEmailFailed(false)
            const res: any = await LavorisInstance.ValidationService.sendResetEmailPassword({ username: data.username })
            //Si el mail existe cambio el estado para que se pueda ver el mensaje de envio del mail
            setEmailRequestSuccesfully(true)
            setDisabled(false)

            if (res.email) {
                setEmailAddressSent(res.email)
            }

        } catch (err: any) {
            console.log(err)
            alert(err?.response?.data?.message);

            //Si el no mail existe, recibo del back un mensaje y lo seteo para que el usuario sepa cual es el problema
            setEmailFailed(true)
            setDisabled(false)
        }
    }

    const sendValidationWsp = async (data: FormValues) => {
        setIsLoading(true);
        setDisabled(true);
        try {
            const res: string = await LavorisInstance.Auth.sendValidationWsp(data.username);
            setPhoneNumber(res);
            setwspSuccesfullySent(true);
        } catch (err: any) {
            alert(err?.response?.data?.message);
            handleClose?.();
        } finally {
            setIsLoading(false);
            setDisabled(false);
        }
    }

    return (
        <> 
            <div className={`login${franchiseLayout ? " login--franchise" : ""}`}>
                {!franchiseLayout && <div className="messages_slide" />}
                <div className="login_right">
                    <div className="company_logo">
                        <FranchiseLogo className="logo" linkToHome={false} />
                        <p>Portal de clientes</p>
                        {franchiseLayout && (
                          <p className="login-franchise-name">
                            {franchiseState.branding?.fantasyName ||
                              franchiseState.branding?.name ||
                              franchiseState.slug}
                          </p>
                        )}
                    </div>
                    {!disabled && (<form onSubmit={handleSubmit(onSubmit)} className="form-row login_form">
                        <div className="form-group">
                            <label htmlFor="username">Tu usuario</label>
                            <input className="form-control" type="text" {...register("username")} />
                        </div>
                        <button type="submit">Recuperar Contraseña</button>
                        {emailRequestSuccesfully && (

                            <div className="success-message">
                                <h2 className="font-bold w-full flex justify-center text-xl">¡Listo! Revisa tu correo</h2>
                                <span className="w-[350px] m-auto mb-3 text-center ">Se te estará enviando un correo electrónico a "{emailAddressSent}" para que puedas crear una nueva contraseña.</span>
                                <span>¿No te llegan los correos?</span>
                                <span 
                                onClick={() => sendValidationWsp({ username: formUsername })}
                                className="text-gray-600 hover:text-blue-800 underline italic transition-colors cursor-pointer">
                                    Probar otro método
                                </span>
                            </div>
                        )}
                    </form>
                    )}
                    {disabled && (
                        <Spinner/>
                    )}
                    <div className="login_options">
                        <div className="mt-6 flex flex-row justify-between">
                            <Link to="/login" className="underline  cursor-pointer">
                                Volver al login
                            </Link>
                        </div>
                    </div>
                    <div className="new_clients">
                        <p>
                            ¿Eres nuevo en Lavorix?{" "}
                            <Link to="/Alta">
                                Regístrate aquí
                            </Link>
                        </p>
                    </div>
                </div>
            </div>

            {!isLoading && wspSuccesfullySent && phoneNumber && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
                    <div className="flex flex-col items-center gap-5 w-[580px] bg-white rounded-xl p-6 shadow-lg">
                        
                        <img src="/images/succesIcon.svg" alt="success" />

                        <h1 className="font-bold text-xl text-[#444444] text-center px-12">
                            Listo
                        </h1>

                        <p className="text-[#777777] text-center">
                            Se te envió un mensaje a {phoneNumber}
                        </p>

                        <PrimaryButton
                            type="button"
                            text="Aceptar"
                            onClick={() => {
                                handleClose?.();
                                setPhoneNumber("");
                                setwspSuccesfullySent(false);
                            }}
                            styles="bg-red-500 font-bold text-white w-52 mb-4"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default ResetPasswordAlert